function LoadingScreen() {
  return (
    <div className="loading">
      <h2>Loading...</h2>
    </div>
  );
}

export default LoadingScreen;
